module.exports = __webpack_public_path__ + "images/sgp/10x15/alt-content-image.webp";